import { Component } from '@angular/core';

@Component({
    selector: 'app-empty-page',
    template: ``,
    styles: [],
    standalone: false
})
export class EmptyPageComponent {}
